"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelFeeStructureForCountry = exports.getPayPalModelForCountry = exports.isCOMMERCECountry = exports.isPPGFCountry = exports.isDIRECTCountry = exports.CAFCountries = exports.DIRECTCountries = exports.PPGFCountries = exports.COMMERCECountries = exports.payPalFeesByModel = void 0;
const payPalVaultingFees_1 = require("./payPalVaultingFees");
const relativeFees = {
    US: {
        SANDBOX: 2.99,
        PRODUCTION: 1.99,
    },
    GB: {
        SANDBOX: 3.19,
        PRODUCTION: 1.4,
    },
    AU: {
        SANDBOX: 3.6,
        PRODUCTION: 1.1,
    },
    CA: {
        SANDBOX: 3.7,
        PRODUCTION: 1.6,
    },
    DE: {
        SANDBOX: 4.98,
        PRODUCTION: 1.5,
    },
};
const fixedFees = {
    US: {
        SANDBOX: 0.49,
        PRODUCTION: 0.49,
    },
    GB: {
        SANDBOX: 0.3,
        PRODUCTION: 0.2,
    },
    AU: {
        SANDBOX: 0.3,
        PRODUCTION: 0.3,
    },
    CA: {
        SANDBOX: 0.3,
        PRODUCTION: 0.3,
    },
};
const payPalFeesByModel = (isSandbox) => {
    const currentPayPalEnvironment = isSandbox ? 'SANDBOX' : 'PRODUCTION';
    return {
        PPGF: {
            US: {
                relativeFee: relativeFees.US[currentPayPalEnvironment], // denominated in %
                fixedFee: fixedFees.US[currentPayPalEnvironment], // denominated in USD
                currencyCode: 'USD',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.25,
                vaultingFee: payPalVaultingFees_1.vaultingRelativeFees.US[currentPayPalEnvironment], // denominated in %
                vaultingFixedFee: payPalVaultingFees_1.vaultingFixedFees.US[currentPayPalEnvironment], // denominated in USD
            },
            GB: {
                relativeFee: relativeFees.GB[currentPayPalEnvironment], // denominated in %
                fixedFee: fixedFees.GB[currentPayPalEnvironment], // denominated in GBP
                currencyCode: 'GBP',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.17,
                vaultingFee: payPalVaultingFees_1.vaultingRelativeFees.GB[currentPayPalEnvironment], // denominated in %
                vaultingFixedFee: payPalVaultingFees_1.vaultingFixedFees.GB[currentPayPalEnvironment], // denominated in GBP
            },
            AU: {
                relativeFee: relativeFees.AU[currentPayPalEnvironment], // denominated in %
                fixedFee: fixedFees.AU[currentPayPalEnvironment], // denominated in AUD
                currencyCode: 'AUD',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.32,
                vaultingFee: payPalVaultingFees_1.vaultingRelativeFees.AU[currentPayPalEnvironment], // denominated in %
                vaultingFixedFee: payPalVaultingFees_1.vaultingFixedFees.AU[currentPayPalEnvironment], // denominated in AUD
            },
            CA: {
                relativeFee: relativeFees.CA[currentPayPalEnvironment], // denominated in %
                fixedFee: fixedFees.CA[currentPayPalEnvironment], // denominated in CAD
                currencyCode: 'CAD',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.32,
                vaultingFee: payPalVaultingFees_1.vaultingRelativeFees.CA[currentPayPalEnvironment], // denominated in %
                vaultingFixedFee: payPalVaultingFees_1.vaultingFixedFees.CA[currentPayPalEnvironment], // denominated in CAD
            },
            IE: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
                vaultingFee: payPalVaultingFees_1.vaultingRelativeFees.IE[currentPayPalEnvironment], // denominated in %
                vaultingFixedFee: payPalVaultingFees_1.vaultingFixedFees.IE[currentPayPalEnvironment], // denominated in EUR
            },
        },
        DIRECT: {
            AT: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            BE: {
                relativeFee: 1.7, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            BG: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            CY: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            CZ: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 10.0, // denominated in CZK
                currencyCode: 'CZK',
            },
            DE: {
                relativeFee: relativeFees.DE[currentPayPalEnvironment], // denominated in %
                fixedFee: 0.39, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
            },
            DK: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 2.6, // denominated in DKK
                currencyCode: 'DKK',
            },
            FR: {
                relativeFee: 1.4, // denominated in %
                fixedFee: 0.25, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
            },
            ES: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
            },
            GR: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            HU: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 90.0, // denominated in HUF
                currencyCode: 'HUF',
            },
            IT: {
                relativeFee: 1.8, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
            },
            LT: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            LV: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            PT: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
            },
            PL: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 1.35, // denominated in PLN
                currencyCode: 'PLN',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.75,
            },
            MT: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            NL: {
                relativeFee: 1.5, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.22,
            },
            BR: {
                relativeFee: 3.25, // denominated in %
                fixedFee: 0.15, // denominated in BRL
                currencyCode: 'BRL',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 0.5,
            },
            MX: {
                relativeFee: 2.95, // denominated in %
                fixedFee: 4.0, // denominated in MXN
                currencyCode: 'MXN',
                payoutApplicationFee: 2.25,
                payoutFixedFee: 2.75,
            },
            NO: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 2.8, // denominated in NOK
                currencyCode: 'NOK',
            },
            SE: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 3.25, // denominated in SEK
                currencyCode: 'SEK',
            },
            SI: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            SK: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            LU: {
                relativeFee: 1.5, // denominated in %
                fixedFee: 0.35, // denominated in EUR
                currencyCode: 'EUR',
            },
            AR: {
                relativeFee: 3.4, // denominated in %
                fixedFee: 0.3, // denominated in USD
                currencyCode: 'USD',
            },
            CR: {
                relativeFee: 5.4, // denominated in %
                fixedFee: 0.3, // denominated in USD
                currencyCode: 'USD',
            },
            PE: {
                relativeFee: 5.4, // denominated in %
                fixedFee: 0.3, // denominated in USD
                currencyCode: 'USD',
            },
            DO: {
                relativeFee: 5.4, // denominated in %
                fixedFee: 0.3, // denominated in USD
                currencyCode: 'USD',
            },
            CH: {
                relativeFee: 1.9, // denominated in %
                fixedFee: 0.55, // denominated in CHF
                currencyCode: 'CHF',
            },
        },
        // Additional fees added to support PayPal Commerce
        // @NOTE-AC: Tested these values with Switzerland in the PayPal Payment form in Sandbox env(!)
        // With other currencies or countries, the fees may be different
        COMMERCE: {
            CH: {
                relativeFee: 3.4, // denominated in %
                fixedFee: 0.55, // denominated in CHF
                currencyCode: 'CHF',
            },
            IL: {
                relativeFee: 3.4, // denominated in %
                fixedFee: 1.2, // denominated in ILS
                currencyCode: 'ILS',
            },
        },
        CAF: {
            US: {
                relativeFee: 2, // denominated in %
                fixedFee: 0, // denominated in USD
                currencyCode: 'USD',
            },
        },
    };
};
exports.payPalFeesByModel = payPalFeesByModel;
// @NOTE-AT: This list of countries is also configured in the nonprofit-db fetch for PayPal: https://github.com/joindeed/marketplace/blob/5aae1cece521e4156329399a1afd205a77ce4966/dagster/app/nonprofits/partitions.py#L7
// Whenever you change this list please make sure to update partitions.py as well
exports.COMMERCECountries = ['CH', 'IL'];
exports.PPGFCountries = ['AU', 'CA', 'GB', 'IE', 'US'];
exports.DIRECTCountries = [
    'AR',
    'AT',
    'BE',
    'BG',
    'BR',
    'CR',
    'CY',
    'CZ',
    'DE',
    'DK',
    'DO',
    'ES',
    'FR',
    'GR',
    'HU',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'MX',
    'NL',
    'NO',
    'PE',
    'PL',
    'PT',
    'SE',
    'SI',
    'SK',
    'CH',
];
exports.CAFCountries = ['US'];
const isDIRECTCountry = (countryCode) => exports.DIRECTCountries.includes(countryCode);
exports.isDIRECTCountry = isDIRECTCountry;
const isPPGFCountry = (countryCode) => exports.PPGFCountries.includes(countryCode);
exports.isPPGFCountry = isPPGFCountry;
const isCOMMERCECountry = (countryCode) => exports.COMMERCECountries.includes(countryCode);
exports.isCOMMERCECountry = isCOMMERCECountry;
const getPayPalModelForCountry = (countryCode) => {
    if ((0, exports.isPPGFCountry)(countryCode)) {
        return 'PPGF';
    }
    if ((0, exports.isDIRECTCountry)(countryCode)) {
        return 'DIRECT';
    }
    if ((0, exports.isCOMMERCECountry)(countryCode)) {
        return 'COMMERCE';
    }
    throw new Error(`PayPal does not support ${countryCode} for donations!`);
};
exports.getPayPalModelForCountry = getPayPalModelForCountry;
const modelFeeStructureForCountry = ({ countryCode, isSandbox, isCAFDonation = false, }) => {
    if (isCAFDonation) {
        if (countryCode !== 'US') {
            throw new Error(`${countryCode} is not a valid CAF country code`);
        }
        return (0, exports.payPalFeesByModel)(isSandbox).CAF[countryCode];
    }
    if ((0, exports.isPPGFCountry)(countryCode)) {
        return (0, exports.payPalFeesByModel)(isSandbox).PPGF[countryCode];
    }
    if ((0, exports.isDIRECTCountry)(countryCode)) {
        return (0, exports.payPalFeesByModel)(isSandbox).DIRECT[countryCode];
    }
    if ((0, exports.isCOMMERCECountry)(countryCode)) {
        return (0, exports.payPalFeesByModel)(isSandbox).COMMERCE[countryCode];
    }
    throw new Error(`${countryCode} is not a valid PPGF, CAF or DIRECT country code`);
};
exports.modelFeeStructureForCountry = modelFeeStructureForCountry;
//# sourceMappingURL=payPalFeesByModel.js.map